/**
 * Configuration for WebPlayerScrlr component
 */
const DEFAULT_BASE_URL = 'https://othentic-dev.web.app';
const TESTING_BASE_URL = 'https://scrlr-prod.web.app';
const TESTING_LOCAL_BASE_URL = 'http://localhost:3080';
function hostSearchParams() {
  if (typeof window === 'undefined') return new URLSearchParams();
  return new URLSearchParams(window.location.search);
}

let helpPlayerUser = null;

export function setHelpPlayerUser(user) {
  helpPlayerUser = user || null;
}

function helpPlayerUserParams(user) {
  if (!user) return null;
  const name = user.name;
  const isObject = name && typeof name === 'object';
  return {
    email: String(user.email || '').trim(),
    name: String(isObject ? (name.full || '') : (name || '')).trim(),
    firstName: String(isObject ? (name.first || '') : '').trim(),
    lastName: String(isObject ? (name.last || '') : '').trim(),
    jobTitle: String((user.zoomData && user.zoomData.jobTitle) || '').trim(),
  };
}

export const SCRLR_CONFIG = {
  // Base URL for the Scrlr iframe.
  // ?testing-local points the iframe at the local player.
  // ?testing points the iframe at the prod player.
  get BASE_URL() {
    const params = hostSearchParams();
    if (params.has('testing-local')) return TESTING_LOCAL_BASE_URL;
    if (params.has('testing')) return TESTING_BASE_URL;
    return DEFAULT_BASE_URL;
  },
  
  // Icon image path
  ICON_IMAGE_PATH: '/scrlr-icon.png',
  
  // Drag and interaction settings
  DRAG: {
    
    OFFSET: 24, // Minimum offset from edges
    CLICK_THRESHOLD: 5, // Minimum pixel movement to consider it a drag (not a click)
    TOP_OFFSET: 124, // Top offset for drag constraints (accounts for header)
  },
  
  // Modal resize settings
  RESIZE: {
    ASPECT_RATIO: 7 / 16, // Aspect ratio (width / height) - 7.5:16 is vertical/portrait
    MIN_WIDTH: 240, // Minimum width in pixels
    MAX_HEIGHT_PERCENT: 0.9, // Maximum height as percentage of viewport height
  },
  
  // Hidden iframe styles (for badge counting)
  HIDDEN_IFRAME_STYLES: 'position:absolute;width:1px;height:1px;opacity:0;pointer-events:none;border:none;left:-9999px;top:-9999px',
  
  // Hidden iframe timeout (in milliseconds) - remove iframe if no message received
  // This prevents the iframe from staying forever if the app doesn't send postMessage
  HIDDEN_IFRAME_TIMEOUT: 30000, // 30 seconds
  
  // Get the URL for the main modal iframe
  getModalUrl: () => `${SCRLR_CONFIG.BASE_URL}/`,
  
  // Get the URL for the hidden iframe (used for badge counting)
  getHiddenUrl: () => `${SCRLR_CONFIG.BASE_URL}/?hidden=true`,

  // Help label names mapped to UI buttons. The player resolves each name
  // to the post that carries that label.
  HELP_LABELS: {
    linkButton: 'linkButton',
    inviteButton: 'inviteButton',
    joinButton: 'joinButton',
    companyView: 'companyView',
    teamsView: 'teamsView',
    myTeamView: 'myTeamView',
    faq: 'faq',
    settings: 'settings',
    dialIn: 'dialIn',
    search: 'search',
    startMeetingButton: 'startMeetingButton',
    statusButton: 'statusButton',
    favoriteButton: 'favoriteButton',
  },

  // Get the URL for the help modal iframe (help view mode).
  // Optional labels select which videos to load; defaults to every help label.
  getHelpUrl: (labels) => {
    const names = labels && labels.length
      ? labels
      : Object.values(SCRLR_CONFIG.HELP_LABELS);
    const params = new URLSearchParams();
    params.set('helpView', '1');
    params.set('labels', names.join(','));
    const person = helpPlayerUserParams(helpPlayerUser);
    if (person) {
      params.set('email', person.email);
      params.set('name', person.name);
      params.set('firstName', person.firstName);
      params.set('lastName', person.lastName);
      params.set('jobTitle', person.jobTitle);
    }
    return `${SCRLR_CONFIG.BASE_URL}/?${params.toString()}`;
  },
  
  // Get max height for resize based on viewport
  getMaxHeight: () => window.innerHeight * SCRLR_CONFIG.RESIZE.MAX_HEIGHT_PERCENT,
};

